/* ==================================================
 *  Alert
 *  ==================================================*/

function showAlert(msg, type) {

  'use strict';

  var $alert = $('.alert');
  var $text = $('.alert__text');
  var typeClass = type || 'success';
  var time = 5000;

  $alert.addClass(typeClass).addClass('in').append($text.text(msg));

  setTimeout(function () {
    $alert.removeClass(typeClass).removeClass('in');
  }, time);
}

var notify = showAlert;
